import React, { useEffect } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import "./headerFooter.scss";
import blackLogo from "../Assets/Images/logoBlack.svg";
import xTwitter from "../Assets/Images/x-twitter.svg";
import instagram from "../Assets/Images/square-instagram.svg";
import linkdln from "../Assets/Images/linkdln.jpg";
import letschat from "../Assets/Images/letschat.svg";
import chatIcon from "../Assets/Images/chat.svg";

export default function Footer(props) {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="footer-container container">
          <div className="row">
            <div className="col-md-6">
              <div className="footer-logo">
                <NavLink className="nav-link" to="/">
                  <img src={blackLogo} alt="Logo" className="logo" />
                </NavLink>
              </div>
              <div className="col-md-6 mt-5">
                <h4 className="footer-heading">Subscribe </h4>

                <div className="input-group d-flex input-group-lg mb-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Your Email"
                  />
                  <div className="input-group-append">
                    <span className="s-bubble">
                      <i className="fa fa-paper-plane"></i>
                    </span>
                  </div>
                </div>
                <p className="footer-para">
                  8/10 <br /> Overall Rating
                  <br />
                </p>
                <span className="d-flex gap-2 rating">
                  <i className="fa fa-star fill"></i>
                  <i className="fa fa-star fill"></i>
                  <i className="fa fa-star fill"></i>
                  <i className="fa fa-star fill"></i>
                  <i className="fa fa-star"></i>
                </span>
              </div>
              <h4 className="footer-heading mt-4">Follow us on </h4>
              <ul className="list-inline d-flex gap-3 mb-0">
                <li>
                  <a href="https://www.facebook.com/popincx"  target="_blank">
                    <span className="social-bubble">
                      <i className="fa fa-facebook"></i>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="https://x.com/popincx"  target="_blank">
                    <span className="social-bubble">
                    <img src={xTwitter} alt="xTwitter"/>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/popincx/"  target="_blank">
                    <span className="social-bubble">
                    <i class="fa fa-instagram"></i>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/popin-cx/" target="_blank">
                    <span className="social-bubble">
                    <i class="fa fa-linkedin"></i>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="col">
              <h4 className="footer-heading">Product</h4>
              <ul className="list-unstyled">
                <li>
                  <NavLink className="nav-link" to="#">
                   Loyalty
                  </NavLink>
                </li>
                <li>
                  <NavLink className="nav-link" to="#">
                  Campaign
                  </NavLink>
                </li>
                <li>
                  <NavLink className="nav-link" to="#">
                  Referral
                  </NavLink>
                </li>
                <li>
                  <NavLink className="nav-link" to="#">
                  Dashboard
                  </NavLink>
                </li>
                <li>
                  <NavLink className="nav-link" to="#">
                    Feedback
                  </NavLink>
                </li>
                <li>
                  <NavLink className="nav-link" to="#">
                    Digital Receipt
                  </NavLink>
                </li>
              </ul>
            </div>
            <div className="col">
              <h4 className="footer-heading">Company</h4>
              <ul className="list-unstyled">
                <li>
                  <NavLink className="nav-link" to="/about-us">
                    About Us
                  </NavLink>
                </li>
                <li>
                  <NavLink className="nav-link" to="/contact-us">
                    Contact Us
                  </NavLink>
                </li>
                <li>
                  <NavLink className="nav-link" to="/terms-conditions">
                    T&amp;C
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink className="nav-link" to="#">
                    System Status
                  </NavLink>
                </li>
                <li>
                  <NavLink className="nav-link" to="#">
                    Tutorials
                  </NavLink>
                </li> */}
              </ul>
            </div>
            {/* <div className="col">
              <h4 className="footer-heading">Resources</h4>
              <ul className="list-unstyled">
                <li>
                  <NavLink className="nav-link" to="#">
                    About
                  </NavLink>
                </li>
                <li>
                  <NavLink className="nav-link" to="#">
                    Leadership
                  </NavLink>
                </li>
                <li>
                  <NavLink className="nav-link" to="#">
                    Press/News
                  </NavLink>
                </li>
                <li>
                  <NavLink className="nav-link" to="#">
                    Careers/Team
                  </NavLink>
                </li>
                <li>
                  <NavLink className="nav-link" to="#">
                    Contact Us
                  </NavLink>
                </li>
              </ul>
            </div> */}
          </div>
        </div>
      </div>
      <div className="container-fluid border-top">
        <div className="bottom-footer">
          <div className="row justify-content-center align-items-center">
            {/* <div className="col-lg-5">
              <ul className="list-inline d-flex gap-5 mb-0">
                <li>
                  <NavLink className="nav-link" to="#">
                    Platform
                  </NavLink>
                </li>
                <li>
                  <NavLink className="nav-link" to="#">
                    Products
                  </NavLink>
                </li>
                <li>
                  <NavLink className="nav-link" to="#">
                    Resources
                  </NavLink>
                </li>
              </ul>
            </div> */}
            <div className="col-lg-12">
              <p className="mb-0 text-center">
                Copyright Easyrewardz {new Date().getFullYear()} | All Rights
                Reserved |{" "}
                <NavLink className="privacy-inline-link" to="/privacy-policy">
                  Privacy Policy
                </NavLink>
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="bottom-chat-container">
        <img src={letschat} className="chat-icon icon-animation" alt="" />
        <img src={chatIcon} className="message-icon icon-animation" alt="" />
      </div> */}
    </footer>
  );
}
